var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1178_8619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.04937 16.0923C9.837 16.0923 11.5735 15.4959 12.9838 14.3974L18.3044 19.718C18.7019 20.1019 19.3353 20.0909 19.7191 19.6934C20.0936 19.3057 20.0936 18.691 19.7191 18.3034L14.3985 12.9827C17.1242 9.47394 16.4895 4.41986 12.9807 1.6941C9.47194 -1.03165 4.41791 -0.396918 1.69215 3.11187C-1.03361 6.62065 -0.398871 11.6747 3.10991 14.4005C4.52252 15.4979 6.26057 16.0932 8.04937 16.0923ZM3.77429 3.77316C6.13538 1.41203 9.96346 1.41199 12.3246 3.77308C14.6857 6.13417 14.6858 9.96224 12.3247 12.3234C9.96359 14.6845 6.13551 14.6846 3.77437 12.3235C3.77433 12.3234 3.77433 12.3234 3.77429 12.3234C1.4132 9.97949 1.39929 6.16537 3.74317 3.80428C3.75353 3.79388 3.76389 3.78352 3.77429 3.77316Z",
    fill: "#717579"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1178_8619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.463bbd96e9cf1e5a7f6e78a8a48af0ec.svg";
export { ForwardRef as ReactComponent };